import React from 'react'
import {withDropdown} from '@modifi/ui'

import {Task} from '../../constants'
import ActionsDropdownContent from './ActionsDropdownContent'
import ActionsDropdownHeader from './ActionsDropdownHeader'
import {ActionsWrapper} from './styles'

const ActionsDropdown = withDropdown({
  toggleComponent: ActionsDropdownHeader,
})(
  ({
    dropdownToggle: ToggleButton,
    ...restProps
  }: {
    dropdownToggle: React.ComponentType<Record<string, unknown>>
  }) => <ToggleButton {...restProps} />
)

type ActionsProps = {
  task: Task
  isLastItem?: boolean
}

const Actions: React.FC<ActionsProps> = ({task, isLastItem = false}) => (
  <ActionsWrapper isLast={isLastItem} data-ident="actions-dropdown-button">
    <ActionsDropdown
      dropdownContent={(props: {closeDropdown?: () => void}) => (
        <ActionsDropdownContent task={task} {...props} />
      )}
      dropdownPosition="right"
      dropdownWidth={240}
      onOpen={undefined}
      onClose={undefined}
    />
  </ActionsWrapper>
)

export default Actions
